import React from "react";
import "./Rights.css";
import {
  FaIdCard,
  FaDoorOpen,
  FaMoneyCheckAlt,
  FaTasks,
  FaHandsHelping
} from "react-icons/fa";

const Rights = () => {
  return (
    <section className="direitos-trabalhistas" id="direitos-trabalhistas">
      <div className="dt-container">
        <h2 className="dt-title">Teve direitos violados no trabalho?</h2>
        <p className="dt-subtitle">
          Se você passou por qualquer situação irregular no ambiente de
          trabalho, é possível buscar seus direitos com orientação jurídica
          adequada.
        </p>

        <div className="dt-grid">
          <div className="dt-card">
            <FaIdCard className="dt-icon" />
            <h3>Reconhecimento de vínculo</h3>
            <p>
              Trabalhou sem carteira assinada? É possível comprovar o vínculo
              empregatício e garantir todos os direitos previstos em lei.
            </p>
          </div>

          <div className="dt-card">
            <FaDoorOpen className="dt-icon" />
            <h3>Rescisão indireta</h3>
            <p>
              Se o empregador cometeu faltas graves, você pode encerrar o
              contrato sem perder seus direitos.
            </p>
          </div>

          <div className="dt-card">
            <FaMoneyCheckAlt className="dt-icon" />
            <h3>Verbas rescisórias</h3>
            <p>
              Revisamos cálculos e buscamos o pagamento correto das verbas
              rescisórias.
            </p>
          </div>

          <div className="dt-card">
            <FaTasks className="dt-icon" />
            <h3>Desvio ou acúmulo de funções</h3>
            <p>
              Exercendo funções além do cargo? É possível cobrar a diferença
              salarial.
            </p>
          </div>

          <div className="dt-card dt-card-full">
            <FaHandsHelping className="dt-icon" />
            <h3>Outros serviços trabalhistas</h3>
            <p>
              Analisamos sua situação, esclarecemos dúvidas e indicamos o melhor
              caminho jurídico para seu caso.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Rights;
